var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstructionHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6813 3.05263C17.6813 2.47128 18.1647 2 18.761 2H20.9203C21.5166 2 22 2.47128 22 3.05263V8.31579C22 8.89714 21.5166 9.36842 20.9203 9.36842H18.761C18.1647 9.36842 17.6813 8.89714 17.6813 8.31579H14.4422V19.8947C14.4422 21.0574 13.4754 22 12.2829 22C11.0903 22 10.1235 21.0574 10.1235 19.8947V8.31579H3.08075C2.31691 8.31579 1.79461 7.56366 2.07829 6.87222L3.10243 4.37602C3.43036 3.57674 4.22437 3.05263 5.10735 3.05263H17.6813Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionHammer);
export default __webpack_public_path__ + "static/media/construction-hammer.0426cf83c5ce12030d07790fa850eedf.svg";
export { ForwardRef as ReactComponent };